import axios from "axios";

export class StorefrontApiError extends Error {
  status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = "StorefrontApiError";
    this.status = status;
  }
}

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_STOREFRONT_API_URL || "http://localhost:5000/api/storefront",
  timeout: 12000,
  headers: { Accept: "application/json" }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.message || error.message || "The store service is unavailable.";
    return Promise.reject(new StorefrontApiError(message, error.response?.status));
  }
);
